import { render, staticRenderFns } from "./about.html?vue&type=template&id=22481194&"
import script from "./about.js?vue&type=script&lang=js&"
export * from "./about.js?vue&type=script&lang=js&"
import style0 from "./about.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports